import { render, staticRenderFns } from "./GroupChoice.vue?vue&type=template&id=1e60146f&"
import script from "./GroupChoice.vue?vue&type=script&lang=js&"
export * from "./GroupChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports